/* eslint-disable @typescript-eslint/no-explicit-any */
import { format } from "date-fns";

import { SwitchRenderer } from "@/components/shared/switch-renderer";
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
// import { Calendar, Clock8 } from "lucide-react";

export const ReactTableCell = ({ header, value, row }: any) => {
  switch (header) {
    case "status": {
      return (
        <SwitchRenderer
          type={value}
          components={{
            Success: (
              <span className="text-green-500 bg-green-50 py-1  border-green-100 border px-3  rounded-[50px] inline-block">
                {value}
              </span>
            ),
            success: (
              <span className="text-green-500 bg-green-50 py-1  border-green-100 border px-3  rounded-[50px] inline-block">
                {value}
              </span>
            ),
            failed: (
              <TooltipProvider delayDuration={0}>
                <Tooltip>
                  <TooltipTrigger className="text-left line-clamp-1">
                    <span className="text-red-500 bg-red-50 py-1 border border-red-100 px-3  rounded-[50px] inline-block">
                      {value}
                    </span>
                  </TooltipTrigger>
                  <TooltipContent>
                    <TooltipArrow />
                    <p>{row?.error || row?.error_message}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            ),
            error: (
              <TooltipProvider delayDuration={0}>
                <Tooltip>
                  <TooltipTrigger className="text-left line-clamp-1">
                    <span className="text-red-500 bg-red-50 py-1 border border-red-100 px-3  rounded-[50px] inline-block">
                      {value}
                    </span>
                  </TooltipTrigger>
                  <TooltipContent>
                    <TooltipArrow />
                    <p>{row?.error || row?.error_message}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            ),
            default: <Badge variant={"outline"}>{value}</Badge>,
          }}
        />
      );
    }

    case "activity": {
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1">
              {value}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{value}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    case "error_message": {
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1">
              {value}
            </TooltipTrigger>
            <TooltipContent>
              <p>{value}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    case "cts": {
      const formattedDate = format(value, "dd-MM-yyyy hh:mm a"); // Format with date and time

      return (
        <span className="flex items-center gap-5">
          <span className=" flex items-center gap-1">{formattedDate}</span>
        </span>
      );
    }

    case "read_at": {
      if (!value) return <span>-</span>;
      try {
        const formattedDate =
          typeof value === "string"
            ? format(new Date(value), "dd-MM-yyyy hh:mm a")
            : value;
        return (
          <span className="flex items-center gap-5">
            <span className="flex items-center gap-1">{formattedDate}</span>
          </span>
        );
      } catch {
        return <span>{value}</span>;
      }
    }

    case "error": {
      if (!value) return <span>-</span>;
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1 text-red-500">
              {value}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{value}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }

    case "ignored_attachments":
    case "read_attachments":
    case "read_emails": {
      if (value === undefined || value === null || value === "")
        return <span>-</span>;
      if (Array.isArray(value)) {
        if (value.length === 0) return <span>-</span>;
        const text = value.join(", ");
        return (
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger className="text-left line-clamp-1">
                {text}
              </TooltipTrigger>
              <TooltipContent>
                <TooltipArrow />
                <p>{text}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        );
      }
      return <span>{value}</span>;
    }

    case "receiver_email":
    case "sender_email": {
      if (!value) return <span>-</span>;
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1">
              {value}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{value}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }

    default: {
      return <span>{value}</span>;
    }
  }
};
